<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <div style="margin:5px;float:right">
            <el-button size="mini" type="success" @click="openModel">添加公告</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="title" label="公告名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="content" label="公告内容" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="时间" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>



        <el-dialog :title="names" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="名称">
                        <el-input v-model="ruleForm.title" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="内容">
                        <el-input v-model="ruleForm.content" placeholder="请输入内容" style="width:70%" type="textarea"
                            :rows="3"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,

        },
        data() {
            return {
                tableData: [],
                loadings: false,
                height: null,
                pageSize: 15,
                curPage: 1,
                count: 0,
                page: '',
                names: '',
                dialogVisible: false,
                rules: {},

                ruleForm: {
                    content: '',
                    title: '',
                },
                eid: '',
                delid: '',


            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.search()
        },
        methods: {
            search() {
                let that = this
                that.loadings = true
                that.page = that.curPage
                let url = `/admin/notice/${that.page}`;
                axios
                    .get(url, {
                        token: true
                    })
                    .then(response => {
                        // console.log(response.data.data.data);

                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                        that.loadings = false
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.curPage = val
                that.search()
            },
            openModel() {
                let that = this
                that.dialogVisible = true
                that.names = "新增"
                that.ruleForm.title = ''
                that.ruleForm.content = ''
            },
            subForm() {
                let that = this
                let urls = `/admin/notice/${that.eid}`;
                if (that.names == "新增") {
                    axios
                        .post("/admin/notice", {

                            title: that.ruleForm.title,
                            content: that.ruleForm.content,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.dialogVisible = false
                                that.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }
                if (that.names == "编辑") {
                    axios
                        .post(urls, {
                            title: that.ruleForm.title,
                            content: that.ruleForm.content,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    message: response.data.msg

                                });
                                that.dialogVisible = false
                                that.search()
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'error'
                                });
                            }
                        })
                        .catch(error => {})
                }

            },
            handleClick(row) {
                let that = this
                that.dialogVisible = true
                that.names = "编辑"
                that.eid = row.id
                that.ruleForm.title = row.title
                that.ruleForm.content = row.content
            },
            // deleteClick(row){
            //    let that = this
            //    that.delid = row.id
            //    let url = `/admin/notice/${that.delid}/delete`;
            //     axios
            //         .get(url, {
            //             token: true
            //         })
            //         .then(response => {

            //         })
            //         .catch(error => {})
            // }

        },
    }
</script>

<style>
</style>